<template>
    <div>
        <Header title="退款订单">
        </Header>
        <div class="my-white-mod">
            <div style="margin-bottom:10px">
                <Input prefix="ios-search" v-model="search_id" placeholder="请输入单号" style="width:200px;margin-left:10px"></Input>
                <Select style="width:187px;margin-left:10px" placeholder="请选择订单状态" v-model="search_type"   >
                    <Option v-for="item in status_list" :value="item.id" :key="item.id">{{ item.name }}</Option>
                </Select>
                <DatePicker type="daterange" placement="bottom-end" placeholder="选择申请时间" style="width: 200px;margin-left:10px"  @on-change="change_date"></DatePicker>
            </div>
            
            <div>
                <DatePicker type="daterange" placement="bottom-end" placeholder="选择订单成交时间" style="width: 200px;margin-left:10px"  @on-change="change_order_date"></DatePicker>  
                <Button  @click="searchList" type="warning" style="margin-left:10px">搜索</Button>
                <Button    @click="ok_export" type="success" style="margin-left:10px">导出</Button>
            </div>
        </div>
        
        <div class="my-white-mod">
            <PageTable  :loading="refund_table.loading" :size="refund_table.limit" :columns="refund_table.columns" :data="refund_table.data" :current="refund_table.current" :total="refund_table.total" @switchPage="change_refund"  >
            </PageTable>
        </div>
        <Modal
                v-model="show_ok_refund"
                title="退款"
                :mask-closable="false"
                width="400"
        >
            <div>申请退款金额</div>
            <Input  disabled v-model="formRefund.money" type="text"  />
            <div style="margin-top: 10px">真实退款金额</div>
            <Input placeholder="请输入退款金额" v-model="formRefund.refund_money" type="text"  />
            <div slot="footer">
                <Button  type="primary"  @click="ok_refund">确定</Button >
            </div>
        </Modal>
    </div>

</template>
<script>
    import {Header, PageTable} from "@/components/mainLayout"
    import {order_refund_list_all,export_refund_list, del_refund, order_back_refuse} from "@/api/order"
   
    export default {
        components:{
            Header,
            PageTable
        },
        data(){
            return{
                search_type:'-1',
                status_list:[
                    {id:'-1', name:'所有'},
                    {id:0, name:'待审核'},
                    {id:1, name:'已通过'},
                    {id:2, name:'已拒绝'}
                ],
                show_ok_refund:false,
                formRefund:{
                    moeny:0,
                    order_id:0,
                    refund_money:0,
                    reason:""
                },
                search_id:"",
                refund_table: {
                    loading:false,
                    current: 1,
                    total: 0,
                    limit: 30,
                    columns: [
                        {
                            type:'index',
                            width:'80',
                            align:'center'
                        },{
                            title: '单号',
                            align:'center',
                            width:'100',
                            key: 'order_id',
                            render: (h, params) => {
                                return h("div", {
                                    domProps:{
                                        innerHTML:params.row.order_id
                                    }
                                })
                            }
                        },{
                            title: '成交时间',
                            align:'center',
                            width:'170',
                            key: 'pay_time',
                            render: (h, params) => {
                                return h('div', [
                                    h('span', {
                                        style:{color:'#445E87'}
                                    }, params.row.order_pay_time.replace("T", " "))
                                ]);
                            }
                        },{
                            title: '申请时间',
                            align:'center',
                            width:'170',
                            key: 'ctime',
                            render: (h, params) => {
                                return h('div', [
                                    h('span', {
                                        style:{color:'#445E87'}
                                    }, params.row.ctime.replace("T", " "))
                                ]);
                            }
                        },{
                            title: '申请金额',
                            align:'center',
                            width:'120',
                            key: 'money'
                        },{
                            title: '申请人',
                            align:'center',
                            width:'200',
                            key: 'depart_name',
                            render: (h, params) => {
                                return h('div', [
                                    h('span', {
                                        style:{color:'#445E87'}
                                    }, params.row.depart_name)
                                ]);
                            }
                        },{
                            title: '退款金额',
                            align:'center',
                            width:'120',
                            key: 'refund_money'
                        },{
                            title: '申请原因',
                            align:'center',
                            width:'200',
                            key: 'apply_desc',
                            render: (h, params) => {
                                return h('Input',{
                                    props: {
                                        value:params.row.apply_desc,
                                        type:'textarea'
                                    }
                                })
                            }
                        },{
                            title: '状态',
                            align:'center',
                            width:'100',
                            key: 'ctime',
                            render: (h, params) => {
                                let text = params.row.refund_status == 0 ? "待审核" : params.row.refund_status == 1 ? "已通过" :"被拒绝"


                                let color = params.row.refund_status == 0 ? "#445E87" : params.row.refund_status == 1 ? "#4caf50" :"#ff0000"
                                return h('div', [
                                    h('span', {
                                        style:{color:color}
                                    }, text)
                                ]);
                            }
                        },{
                            title: '审核时间',
                            align:'center',
                            width:'170',
                            key: 'refund_time',
                            render: (h, params) => {
                                return h('div', [
                                    h('span', {
                                        style:{color:'#445E87'}
                                    }, params.row.refund_time ? params.row.refund_time.replace("T", " ") : "")
                                ]);
                            }
                        },{
                            title: '拒绝原因',
                            align:'center',
                            width:'200',
                            key: 'reason',
                            render: (h, params) => {
                                return h('Input',{
                                    props: {
                                        value:params.row.reason,
                                        type:'textarea'
                                    }
                                })
                            }
                        },{
                            title: '操作',
                            align:'center',
                            key: 'id',
                            fixed: 'right',
                            width:140,
                            render: (h, params) => {
                                let btnArr = []
                                3
                                let okBtn = h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    style:{color:'#3F8CFF',cursor:'pointer'},
                                    on: {
                                        click: () => {
                                            this.formRefund.status = 1;
                                            this.formRefund.id = params.row.id
                                            this.formRefund.money = params.row.money
                                            this.formRefund.refund_money = params.row.money
                                            this.show_ok_refund = true
                                        }
                                    }
                                }, '同意')
                                let refuseBtn = h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    style:{color:'#ff0000',cursor:'pointer'},
                                    on: {
                                        click: () => {
                                            this.formRefund.status = 2;
                                            this.formRefund.id = params.row.id
                                            this.formRefund.refund_money = 0
                                            this.refuse_refund_order(params.row.id)
                                        }
                                    }
                                }, '拒绝')

                                let backbtn = h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    style:{color:'#000000'},
                                    on: {
                                        click: () => {
                                            this.formRefund.id = params.row.id
                                            this.back_refuse_order(0)
                                        }
                                    }
                                }, '回撤')

                                if (params.row.refund_status == 0) {
                                    btnArr.push(okBtn)
                                    btnArr.push(refuseBtn)
                                }
                                if (params.row.refund_status != 0) {
                                    btnArr.push(backbtn)
                                }

                                return h('div', btnArr);

                            }

                        }],
                    data:[]
                },
                commit:0,
                start_date:"",
                end_date:"",
                pay_start_date:"",
                pay_end_date:"",
            }
        },
        mounted(){
            this.refund_list()
        },
        methods:{
            
            change_date(e){
                this.start_date = e[0]
                this.end_date = e[1]
            },
            change_order_date(e){
                this.pay_start_date = e[0]
                this.pay_end_date = e[1]
            },
            refund_list(){
                
                let val = {limit:this.refund_table.limit, page:this.refund_table.current, search_type:this.search_type};
                if(this.search_id != "") {
                    val.search_id = this.search_id
                }
                if(this.start_date != "") {
                    val.start_date = this.start_date
                }
                if(this.end_date != "") {
                    val.end_date = this.end_date
                }
                if(this.pay_start_date != "") {
                    val.pay_start_date = this.pay_start_date
                }
                if(this.pay_end_date != "") {
                    val.pay_end_date = this.pay_end_date
                }
                this.refund_table.loading = true;
                order_refund_list_all(val).then(res=>{
                    this.refund_table.loading = false;
                    if (res.code == 200) {
                        this.refund_table.data = res.data;
                        this.refund_table.total = res.total;
                    } else {
                        this.refund_table.data = [];
                        this.refund_table.total = 0;
                        this.$Message.error(res.msg);
                    }
                })
            },
            ok_export(){
                let val = {search_type:this.search_type};
                if(this.search_id != "") {
                    val.search_id = this.search_id
                }
                if(this.start_date != "") {
                    val.start_date = this.start_date
                }
                if(this.end_date != "") {
                    val.end_date = this.end_date
                }
                if(this.pay_start_date != "") {
                    val.pay_start_date = this.pay_start_date
                }
                if(this.pay_end_date != "") {
                    val.pay_end_date = this.pay_end_date
                }
                
                this.$Message.info({
                    content: '处理数据中，请等待',
                    duration: 0
                });
                let _this = this;
                export_refund_list(val).then(res=>{
                    this.$Message.destroy()
                    if(res.code == 200) {
                        let url = res.data
                        if (navigator.userAgent.indexOf("Safari") > -1) {
                            const newPage = window.open("newPage", "_blank");
                            newPage.location = url;
                        } else {
                            window.open(url, "_blank").location;
                        }
                    } else {
                        this.$Message.error(res.msg);
                    }
                    setTimeout(function(){
                        _this.commit = 0;
                    }, 500)
                }).catch(err=>{
                    this.$Message.destroy()
                    setTimeout(function(){
                        _this.commit = 0;
                    }, 500)
                })
            },
            searchList(){
                this.refund_table.current = 1
                this.refund_list()
            },
            ok_refund(){

                if (this.commit == 1) {
                    return
                }
                if ( this.formRefund.status == 1&& (this.formRefund.refund_money == "" || this.formRefund.refund_money == 0)) {
                    this.$Message.error("请输入真实退款金额");return
                }
                this.$Message.info({
                    content: '提交中',
                    duration: 0
                });
                this.commit = 1;
                let _this = this
                del_refund(this.formRefund).then(res=>{
                    this.$Message.destroy()
                    if (res.code == 200) {
                        this.refund_list()
                        this.show_ok_refund = false;
                        this.$Message.success(res.msg);
                    } else {
                        this.$Message.error(res.msg);
                    }
                    setTimeout(function(){
                        _this.commit = 0;
                    }, 500)
                })
            },

            back_refuse_order(e){
                this.$Modal.confirm({
                    title: '提示',
                    content: '<p>确认将此订单回撤为待审核状态？</p>',
                    onOk: () => {
                        order_back_refuse(this.formRefund).then(res=>{
                            if (res.code == 200) {
                                this.refund_list()
                                this.$Message.success(res.msg);
                            } else {
                                this.$Message.error(res.msg)
                            }
                        })
                    }
                });
            },
            refuse_refund_order(){
                this.$Modal.confirm({
                    title: '<p>请输入拒绝原因</p>',
                    onOk: () => {

                        if (this.formRefund.reason == "" || this.formRefund.reason == undefined) {
                            this.$Message.error("请输入拒绝原因");return
                        }
                        this.ok_refund()
                    },
                    render: (h) => {
                        return h('Input', {
                            props: {
                                value: this.value,
                                autofocus: true,
                                placeholder: '请输入拒绝原因',
                                type:'textarea'
                            },
                            on: {
                                input: (val) => {
                                    this.formRefund.reason = val;
                                }
                            }
                        })
                    }
                })
            },

            change_refund(e){
                this.refund_table.current = e;
                this.refund_list();
            },

        }
    }
</script>
